import { ExtendableError } from '../misc';
export class TimeoutError extends ExtendableError {
    constructor() {
        super('Request timed out');
        this.name = 'TimeoutError';
    }
}
export class HTTPError extends ExtendableError {
    status;
    constructor(response) {
        super('Request failed');
        this.name = 'HTTPError';
        this.status = response?.status;
    }
}
